import { Form } from 'formik';
// eslint-disable-next-line
import React, { FC } from 'react';

/**
 * Helper to deal with formik forms
 */

const WizardForm: FC<any> = ({ children, ...props }) => {
  return (
    <Form
      noValidate
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
      {...props}
    >
      {children}
    </Form>
  );
};

export default WizardForm;
